import { render, staticRenderFns } from "./KioskIdleWarningModal.vue?vue&type=template&id=60c35874&scoped=true"
import script from "./KioskIdleWarningModal.vue?vue&type=script&lang=js"
export * from "./KioskIdleWarningModal.vue?vue&type=script&lang=js"
import style0 from "./KioskIdleWarningModal.vue?vue&type=style&index=0&id=60c35874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c35874",
  null
  
)

export default component.exports